import { Area } from './types';

export const MIN_ZOOM = 0.7;
export const DEFAULT_ZOOM = 1;
export const MAX_ZOOM = 4;
export const SNAP_THRESHOLD = 15;
export const ZOOM_SNAP_THRESHOLD = 0.1;
export const OUTPUT_WIDTH = 1920;
export const ZOOM_STEP_VALUE = 0.2;
export const AVATAR_CIRCLE_INSET = 40;
export const DEFAULT_CROP_AREA: Area = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
};
